export default __webpack_public_path__ + "static/media/icon-nsl.c607baef.svg";